const STATUS_COPY = {
    idle: '',
    saving: 'Se salveaza...',
    saved: 'Salvat',
    error: 'Eroare',
}

export default function InlineStatusField({
    label,
    status = 'idle',
    errorMessage = '',
    children,
    className = '',
}) {
    const statusText = status === 'error' && errorMessage ? errorMessage : STATUS_COPY[status]

    return (
        <div className={`inline-status-field ${className}`.trim()}>
            <div className="inline-status-field-header">
                <label className="inline-status-field-label">{label}</label>
                {statusText ? (
                    <span className={`inline-status-field-state ${status}`}>
                        {statusText}
                    </span>
                ) : null}
            </div>
            {children}
        </div>
    )
}
